import { BrandliveEvent, SelectedBrandliveEvent } from '@/types/projects.types';
import { SessionPreview } from '@/types/session.types';

export const formatTime = (_date: number | Date) => {
  const date = new Date(_date);

  return (
    date.toLocaleString(navigator.language, { month: 'short', day: 'numeric', year: 'numeric' }) +
    ' • ' +
    date.toLocaleString(navigator.language, { hour: 'numeric', minute: 'numeric', timeZoneName: 'short' })
  );
};
const extractTimestamp = (session: SessionPreview) => session.timestamp;
const isDefined = (timestamp: number | undefined | null) => !!timestamp;

export function getProjectStartTime({
  project,
}: {
  project: BrandliveEvent | SelectedBrandliveEvent;
}): string | null | number {
  if (!project) return null;

  if ('start_timestamp' in project && project.start_timestamp) {
    return project.start_timestamp;
  }

  // sessions could be Session[] or SessionPreview[], but TS doesnt like that when filtering the sessions.
  // since all we need here is the timestamp, SessionPreview will work for both types
  const sessions: SessionPreview[] =
    ((project.sessions ? project.sessions : project.sessionsPreviews) as SessionPreview[]) ?? [];

  const allSessionTimestamps = sessions.map(extractTimestamp).filter(isDefined);

  const startTime = allSessionTimestamps.length ? Math.min(...allSessionTimestamps) : null;

  if (startTime === null || startTime === 0) {
    return null;
  }

  return startTime;
}

export function getFormattedProjectStartTime({ project }: { project: BrandliveEvent }): string | null {
  const startDate = getProjectStartTime({ project });
  if (!startDate) {
    return null;
  }
  return formatTime(new Date(startDate).getTime());
}
